import { E_COMM_URL } from 'common/api/config';
import { withTokensIfNeeded } from 'common/api/utils/withTokensIfNeeded';
import { CategoryData } from 'common/api/categories/models/CategoryData';

export const getCategoryById = (categoryId: number) =>
    withTokensIfNeeded<CategoryData>(`${E_COMM_URL}/Products/categories/${categoryId}`);
